import { matchPath } from 'react-router-dom';

export const ONBOARDING_PORTAL_ROUTE = '/onboarding/:businessSlug';
export const ONBOARDING_PORTAL_NOT_FOUND_ROUTE = '/onboarding/*';
export const ONBOARDING_REVIEW_ROUTE = '/onboarding-review';
export const LEGACY_RESERVED_SLUG_NOT_FOUND_ROUTE = '/:reservedSlug';

export function isOnboardingPortalPath(pathname: string): boolean {
    return matchPath({ path: ONBOARDING_PORTAL_ROUTE, end: true }, pathname) !== null;
}

export function isInvalidOnboardingPortalPath(pathname: string): boolean {
    return !isOnboardingPortalPath(pathname)
        && matchPath({ path: ONBOARDING_PORTAL_NOT_FOUND_ROUTE, end: true }, pathname) !== null;
}

export function isLegacyReservedSlugPath(pathname: string): boolean {
    return matchPath({ path: LEGACY_RESERVED_SLUG_NOT_FOUND_ROUTE, end: true }, pathname) !== null;
}
